<template>
    <div class="row">
        <div class="col col-md-4">
            <div class="row">
                <div class="col col-md-12">
                    <label class="input-label">{{ $t('lesson.number_of_persons') }}</label>
                    <b-form-input
                        class="input-persons"
                        v-model="numPersons"></b-form-input>
                </div>
            </div>
            <div
                class="row"
                style="margin-top: 10px">
                <div class="col col-md-12">
                    <label class="input-label">{{ $t('lesson.group_size') }}</label>
                    <b-form-input
                        class="input-persons"
                        v-model="groupSize"></b-form-input>
                </div>
            </div>
            <div
                class="row"
                style="margin-top: 10px">
                <div class="col col-md-12">
                    <button
                        class="btn btn-primary btn-sm"
                        style="background: rgb(56, 144, 207); border-color: rgb(56, 144, 207)"
                        @click="createGroups">
                        {{ $t('lesson.create_groups') }}
                    </button>
                </div>
            </div>
            <div
                class="row"
                style="margin-top: 10px">
                <div class="col col-md-12">
                    <button
                        class="btn btn-primary btn-sm"
                        style="background: rgb(56, 144, 207); border-color: rgb(56, 144, 207)"
                        @click="pickRandom">
                        {{ $t('lesson.who_o_who') }}
                    </button>
                </div>
            </div>
        </div>
        <div
            class="col col-md-4"
            v-if="groups.length >= 8">
            <div
                class="group-number"
                v-for="(group, index) in groups"
                v-if="index <= 5">
                <label class="group-head">{{ $t('lesson.group') }} {{ index + 1 }}:</label>
                <span
                    class="person-number"
                    v-for="item in group"
                    :class="isSelected(item)"
                    >{{ item }}</span
                >
            </div>
        </div>
        <div
            class="col col-md-4"
            v-if="groups.length >= 8">
            <div
                class="group-number"
                v-for="(group, index) in groups"
                v-if="index > 5">
                <label class="group-head">{{ $t('lesson.group') }} {{ index + 1 }}:</label>
                <span
                    class="person-number"
                    v-for="item in group"
                    :class="isSelected(item)"
                    >{{ item }}</span
                >
            </div>
        </div>
        <div
            class="col col-md-8"
            v-if="groups.length < 8">
            <div
                class="group-number"
                v-for="(group, index) in groups">
                <label class="group-head">{{ $t('lesson.group') }} {{ index + 1 }}:</label>
                <span
                    class="person-number"
                    v-for="item in group"
                    :class="isSelected(item)"
                    >{{ item }}</span
                >
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'design-2021-lesson-show-slide-generator-component',
    props: ['slideIn'],
    data() {
        return {
            numPersons: 30,
            groupSize: 5,
            groups: [],
            selected: null,
        };
    },
    watch: {
        slideIn(value) {
            this.slide = value;
        },
    },
    methods: {
        pickRandom() {
            this.selected = Math.floor(Math.random() * this.numPersons) + 1;
        },
        isSelected(item) {
            return item == this.selected ? 'selected' : '';
        },
        createGroups() {
            var personsArray = [];
            var groupsArray = [];
            var numGroups = Math.floor(this.numPersons / this.groupSize);
            var currentGroup = 0;
            this.selected = null;

            for (var i = 1; i <= this.numPersons; i++) {
                personsArray.push(i);
            }

            personsArray = this.shuffle(personsArray);

            for (var i = 0; i < personsArray.length; i++) {
                if (i != 0 && i % this.groupSize == 0) {
                    currentGroup++;
                }

                if (groupsArray[currentGroup]) {
                    groupsArray[currentGroup].push(personsArray[i]);
                } else {
                    groupsArray[currentGroup] = [];
                    groupsArray[currentGroup].push(personsArray[i]);
                }
            }

            this.groups = groupsArray;
        },
        shuffle(array) {
            var currentIndex = array.length,
                temporaryValue,
                randomIndex;

            while (0 !== currentIndex) {
                randomIndex = Math.floor(Math.random() * currentIndex);
                currentIndex -= 1;

                temporaryValue = array[currentIndex];
                array[currentIndex] = array[randomIndex];
                array[randomIndex] = temporaryValue;
            }

            return array;
        },
    },
};
</script>

<style scoped>
.input-label {
    width: 140px;
    float: left;
    line-height: 35px;
}
.input-persons {
    width: 100px;
    float: left;
    border: 1px solid #000;
}
.group-number {
    clear: both;
}
.group-head {
    float: left;
    width: 110px;
    line-height: 50px;
    font-size: 1.5em;
}
.person-number {
    border: 1px solid #000;
    margin: 5px;
    width: 50px;
    height: 40px;
    display: block;
    float: left;
    line-height: 40px;
    text-align: center;
    font-size: 1.5em;
}
.person-number.selected {
    background: #007bff;
    color: #fff;
}
</style>
